<template>
  <form @submit.prevent="onSubmit">
    <div class="form-row align-items-center">
      <div class="col-auto">
        <label class="sr-only" for="name">Название</label>
        <input
            class="form-control mb-2"
            id="name"
            v-model="local.name"
            type="text"
            placeholder="Название"
            required
        >
      </div>
      <div class="col-auto" v-if="!props.initial?.balance">
        <label class="sr-only" for="balance">Баланс</label>
        <input
            ref="balanceRef"
            class="form-control mb-2"
            id="balance"
            v-model="local.balance"
            inputmode="decimal"
            placeholder="1000"
            required
        >
      </div>
      <div class="col-auto" v-if="props.initial?.currency == null || props.initial?.currency === ''">
        <label class="sr-only" for="account">Валюта</label>
        <select
            id="currency"
            class="form-control mb-2"
            v-model="local.currency"
            required
        >
          <option
              v-for="currency in currencies"
              :key="currency.id"
              :value="currency.id"
              :selected="currency.id === local.currency"
          >
            {{ currency.name }}
          </option>
        </select>
      </div>
      <div class="text-danger g-3 mt-3 d-flex justify-content-center align-items-center" v-if="props.errorMessage">
        <span>{{ props.errorMessage }}</span>
      </div>
      <div class="col-auto g-3 mt-3">
        <button class="btn btn-primary mb-2" type="submit">
          Сохранить
        </button>
      </div>
    </div>
  </form>
</template>

<script setup>
import {onMounted, reactive, ref} from "vue";
import {normalizeAmountInput} from "@/api/helpers";

const emit = defineEmits(['submit']);

const props = defineProps({
  initial: { type: Object, required: false },
  currencies: { type: Object, required: true },
  errorMessage: {type: String, required: false },
});
const local = reactive({
  id: props.initial?.id ?? '',
  name: props.initial?.name ?? '',
  balance: props.initial?.balance ?? '',
  currency: props.initial?.currency ?? '',
});

function onSubmit() {
  emit('submit', {...local});
}

const balanceRef = ref(null);
onMounted(async () => {
  if (balanceRef.value) normalizeAmountInput(balanceRef);
});
</script>
